import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";
import { Grid, FormControl, InputLabel } from "@material-ui/core";
import Button from "components/CustomButtons/Button.jsx";
import InlineDatePicker from "../../utils/InlineDatePicker";
import { appConstants } from "../../_constants";
import AutocompleteSelect from "../../utils/AutocompleteSelect";
import CustomInput from "components/CustomInput/CustomInput.jsx";

const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  formRoot: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  searchButton: {
    // backgroundColor: " #66bb6a",
    marginTop: "32px"
  },
  airlineSelect: {
    marginTop: "0px",
    width: "100%",
  },
});

function AirlinePaymentPanel(props) {
  const {
    user,
    classes,
    selectOnChange,
    data,
    onSearch,
    startDate,
    handleDateChange,
    endDate,
    startLabel,
    endLabel,
    locationData,
    airportLocation,
    AirlineId,
    selectChange
  } = props;

  return (
    <div className={classes.root}>
      <Grid container spacing={24}>
        <Grid item lg={3}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
              Airlines
            </InputLabel>
            <AutocompleteSelect
              options={data.map((option) => ({
                value: option.AirlineId,
                label: option.Airline,
              }))}
              selectedOption={AirlineId}
              handleSelectChange={(e, name) => selectChange(e, name)}
              // selectLabel={"Airlines"}
              disabled={user.AppRole === appConstants.ROLES.AIRLINE}
              name={"AirlineId"}
            />
            {/* <Select
                disabled={user.AppRole === appConstants.ROLES.AIRLINE}
                value={AirlineId}
              onChange={selectChange}
              input={<Input name="airline" id="airline-label-placeholder" />}
              // displayEmpty
              name="AirlineId"
              className={classes.selectEmpty}
            >
              <MenuItem value="-1">All Airlines</MenuItem>
              {data.map((option, i) => (
                <MenuItem
                  key={i}
                  value={option.AirlineId}
                  className={classes.select}
                >
                  {option.Airline}
                </MenuItem>
              ))}
            </Select>
            */}
          </FormControl>
        </Grid>
        <Grid item lg={3}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
              Airports
            </InputLabel>
            <AutocompleteSelect
              options={locationData.map((option) => ({
                value: option.Code,
                label: option.Name,
              }))}
              selectedOption={airportLocation}
              handleSelectChange={(e, name) => selectChange(e, name)}
              selectLabel={"Airports"}
              disabled={
                user.AppRole === appConstants.ROLES.AIRPORT_MANAGER ||
                user.Location
              }
              name={"airportLocation"}
            />
            {/* <Select
                      // disabled={user.AppRole === appConstants.ROLES.AIRLINE}
                      value={airportLocation}
                      disabled={user.AppRole === appConstants.ROLES.AIRPORT_MANAGER || (user.Location) }
                      onChange={selectChange}
                      input={<Input name="airline" id="airline-label-placeholder" />}
                      // displayEmpty
                      name="airportLocation"
                      className={classes.selectEmpty}
                  >
                      <MenuItem value="-1">All Airports</MenuItem>
                      {locationData.map((option, i) => (
                          <MenuItem
                              key={i}
                              value={option.Code}
                              className={classes.select}
                          >
                              {option.Name}
                          </MenuItem>
                      ))}
                  </Select>
                  */}
          </FormControl>
        </Grid>
        
        <Grid item lg={3}>
          <div className="picker">
            <InlineDatePicker
              Date={startDate}
              handleDateChange={(date) => handleDateChange(date, "startDate")}
              label={startLabel}
            />
          </div>
        </Grid>
        <Grid item lg={3}>
          <div className="picker">
            <InlineDatePicker
              Date={endDate}
              handleDateChange={(date) => handleDateChange(date, "endDate")}
              label={endLabel}
            />
          </div>
        </Grid>
        <Grid item lg={3}>
          <FormControl
            className={classNames(classes.inputSelect)}
          >
            <CustomInput
              style={{ marginTop: "-2px"}}
              className={classNames(classes.input)}
              required
              labelText="Invoice Number"
              id="invoiceNumber"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                name: "invoiceNumber",
                type: "number",
                onChange: selectOnChange,
              }}
            />
          </FormControl>
        </Grid>
        <Grid item lg={2}>
          <Button 
          className={classes.searchButton}
          onClick={onSearch} 
          color="regional">
            Search
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}

AirlinePaymentPanel.propTypes = {
  // classes: PropTypes.object.isRequired,
  // airlines: PropTypes.string.isRequired,
  // data: PropTypes.object.isRequired,
  // selectChange: PropTypes.func.isRequired
};

export default withStyles(styles)(AirlinePaymentPanel);



// WEBPACK FOOTER //
// ./src/Regional-Views/AirlinePayment/AirlinePaymentPanel.jsx